import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import helpers from '../lib/helpers';
import store, {actions} from '../store';
import auth from '../lib/auth';
import _ from 'lodash';

export default class DiscussionList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      initializing: true,
      discussions: [],
      user: {},
    };
  }

  async componentDidMount() {
    let [discussions, user] = await Promise.all([
      store.dispatch(actions.discussions.fetchAll()),
      auth.user(),
    ]);
    this.setState({
      initializing: false,
      discussions,
      user,
    });
  }

  redirectTo(path) {
    this.props.history.push(path);
  }

  renderListItem(discussion) {
    let path = `/discussions/${discussion.discussionId}`;
    return (
        <div className="discussions-row">
          <div className="row align-items-center"
               style={{
                 cursor: 'pointer',
               }}
               onClick={this.redirectTo.bind(this,path)}
          >
            <div
                className="col-md-4 col-sm-4 col-12 text-md-left text-sm-left text-center">
              <h3>{discussion.name}</h3>
            </div>
            <div className="col-md-4 col-sm-4 col-12 text-center">
                                        <span className="Created-time">
                                            Created: {new Date(
                                            discussion.createdAt).toLocaleDateString()}
                                        </span>
            </div>
            <div
                className="col-md-4 col-sm-4 col-12 text-md-right text-sm-right text-center">
              <RouterLink to={path}
                          onClick={e => e.preventDefault()}
                          className="view-dis">
                View Discussion
              </RouterLink>
            </div>
          </div>
        </div>
    );
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() : (
        <div className="Discussion">
          <div className="box-panel">
            <div
                className="box-panel--head summary clearfix d-flex align-items-center">
              <div className="title">
                <h2>Discussions Summary</h2>
              </div>
              <div style={{flexGrow: '10'}}></div>
              <RouterLink to="/discussions/create" className="btn btn-purple">
                New Discussion
              </RouterLink>
            </div>
            <div className="progreesbtm discussions"
                 style={{'height': 'auto', 'padding': 0}}>
              {
                this.state.discussions.length === 0 ? (
                    <div className="discussions-row">
                      <div
                          className="row align-items-center d-flex justify-content-center">
                        <i>No Discussions</i>
                      </div>
                    </div>
                ) : (
                    _.map(this.state.discussions,
                        (discussion) => this.renderListItem(discussion))
                )
              }
            </div>
          </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/DiscussionList.js